import { 
  Calendar, 
  Clock, 
  History, 
  Inbox, 
  Repeat, 
  Settings, 
  Folder, 
  Flag, 
  List, 
  BarChart3 
} from 'lucide-react';

export const navigationGroups = [
  {
    label: 'Tasks',
    items: [
      {
        title: 'Inbox',
        href: '/inbox',
        icon: Inbox,
      },
      {
        title: 'Priority',
        href: '/priority',
        icon: Flag,
      },
      {
        title: 'Projects',
        href: '/projects',
        icon: Folder,
      },
    ],
  },
  {
    label: 'Plan',
    items: [
      {
        title: 'Today',
        href: '/today',
        icon: Clock,
      },
      {
        title: 'All',
        href: '/all',
        icon: List,
      },
      {
        title: 'Scheduled',
        href: '/scheduled',
        icon: Calendar,
      },
      {
        title: 'Recurring',
        href: '/recurring',
        icon: Repeat,
      },
    ],
  },
  {
    label: 'Context',
    items: [
      {
        title: 'Goals',
        href: '/goals',
        icon: BarChart3,
      },
      {
        title: 'Logs',
        href: '/logs',
        icon: History,
      },
      {
        title: 'Settings',
        href: '/settings',
        icon: Settings,
      },
    ],
  },
];